
import { defineComponent } from 'vue';

import { APPROVAL_STATUS_DECLINED_REASONS } from '@/libs/consts';

import useUser from '@/composable/useUser';

export default defineComponent({
  props: {
    modelValue: {
      type: String,
      default: null,
    },
  },
  setup(props, { emit }) {
    const { activeUser: user } = useUser();

    const applyReason = (reason: string): void => {
      emit('update:modelValue', reason);
    };

    return {
      user,
      APPROVAL_STATUS_DECLINED_REASONS,
      applyReason,
    };
  },
});
